export default "/images/pay-white-logo.png?ac50a18296ee5841aee8af09794bb191";